import {
  removeStoredChatListCollaboration,
  resetStoredRoomUnreadCount,
} from "../services/chatListStorageCache";
import * as chatSlice from "./ChatSlice.v2";

export const reconcileOutgoingReplyUnread =
  ({
    collaborationId,
    roomId,
  }: {
    collaborationId: string;
    roomId: string;
  }) =>
  (dispatch: any) => {
    if (!collaborationId) return;

    if (roomId) {
      dispatch(
        chatSlice.resetRoomUnreadCount({
          chatType: "myChat",
          collaborationId,
          roomId,
        })
      );
      resetStoredRoomUnreadCount("myChat", collaborationId, roomId);
    }

    dispatch(
      chatSlice.removeCollaboration({
        chatType: "allChat",
        id: collaborationId,
      })
    );
    removeStoredChatListCollaboration("allChat", collaborationId);
  };
